import angular from 'angular';
import { default as docDataService } from 'app/services/data/doc.data.service';
import documentAssociationDialog from '../dialog.documentAssociationDialog';
import controller from './add-edit-folder-dialog.controller';
import template from './add-edit-folder-dialog.html';
import messagesTpl from './messages.required.html';
import someSelectedTpl from './services.some-selected.messages.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions($event, {
    parentFolderId = null,
    folderId = null,
    customerId = null,
    serviceId = null,
    folderName = '',
    folder = null,
    parentFolder = null,
    maxSubFolderNameLength = null,
    updateCallback = null
  }) {
    return {
      controller,
      controllerAs: 'addEditFolderDialogVM',
      locals: {
        parentFolderId,
        folderId,
        customerId,
        serviceId,
        folderName,
        folder,
        parentFolder,
        maxSubFolderNameLength,
        updateCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.documentManagement.addEditFolderDialog', [
  ssDialogService,
  loaderService,
  alerts,
  confirmDialog,
  documentAssociationDialog,
  docDataService,
])
  .service('addEditFolderDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('messages.required.html', messagesTpl);
    $templateCache.put('services.some-selected.messages.html', someSelectedTpl);
  })
  .name;

console.log('app.components.global.documentManagement.addEditFolderDialog created');
